<template>
  <div class="container-fluid default-dashboard pt-2">
    <div class="col-12">
      <div class="row">
        <div class="d-flex flex-column flex-md-row gap-3 mb-3">
          <!-- Filter controls wrapper -->
          <div class="d-flex flex-column flex-md-row gap-2 flex-grow-1">
            <!-- Date inputs -->
            <div class="d-flex flex-column flex-sm-row gap-2">
              <input 
                v-model="params.start_date" 
                class="form-control" 
                type="datetime-local"
                placeholder="Start Date"
              >
              <input 
                v-model="params.end_date" 
                class="form-control" 
                type="datetime-local"
                placeholder="End Date"
              >
            </div>

            <!-- Select inputs -->
            <div class="d-flex flex-column flex-sm-row gap-2">
              <select v-model="params.divisi_id" class="form-select">
                <option value="">Select ALL Divisi</option>
                <option 
                  v-for="option in divisiOptions" 
                  :key="option.ID" 
                  :value="option.ID"
                >
                  {{ (option as any).name }}
                </option>
              </select>

              <select v-model="params.divisi_team_id" class="form-select">
                <option value="">Select ALL Divisi Team</option>
                <option 
                  v-for="option in divisiTeamOptions" 
                  :key="option.ID" 
                  :value="option.ID"
                >
                  {{ (option as any).name }}
                </option>
              </select>
            </div>

            <!-- Action buttons -->
            <div class="d-flex gap-2">
              <button 
                class="btn btn-primary" 
                type="button" 
                @click="updateParams"
              >
                <i class="fa fa-search"></i>
              </button>
              <button 
                class="btn btn-success d-md-none" 
                @click="exportAllToExcel"
              >
                <i class="fa fa-file-excel"></i>
              </button>
            </div>
          </div>

          <!-- Export button for larger screens -->
          <button 
            class="btn btn-success d-none d-md-flex align-items-center" 
            @click="exportAllToExcel"
          >
            <i class="fa fa-file-excel me-1"></i>
            <span>Export Data</span>
          </button>
        </div>
      </div>
      <div class="row">
        <div class="row general-widget">
          <Card1 colClass="col-sm-6 col-xl-3 box-col-6" cardClass="card widget-1" v-for="(item, index) in widgets"
            :key="index">
            <div class="widget-content">
              <div class="widget-round " :class="item.class">
                <div class="bg-round">
                  <svg class="svg-fill">
                    <use :xlink:href="`/icon-sprite.svg#${item.svg1}`"></use>
                  </svg>
                  <svg class="half-circle svg-fill">
                    <use :xlink:href="`/icon-sprite.svg#${item.svg2}`"></use>
                  </svg>
                </div>
              </div>
              <div>
                <h4>{{ formatCurrency(item.number) }}</h4><span class="f-light">{{ item.title }}</span>
              </div>
            </div>
          </Card1>
        </div>
        <!-- <div class="col-md-6">
          <div class="row">
            <Card1 colClass="col-xxl-12 col-xl-12 proorder-xxl-12 col-lg-12 col-md-12 box-col-12" cardClass="card"
              cardHeaderClass="card-no-border pb-0" header="true" :title="`History Order ${params.divisi_name}`"
              cardbodyClass="transaction-history pt-0">
              <div class="table-responsive theme-scrollbar">
                <DataTable :headers="headers" :items="orderHistory" :loading="loading" :total="total" :params="params"
                  @update:params="updateParams">
                  <template #item.transaction_date="{ item }" style="white-space: nowrap;word-wrap: break-word;">
                    {{ formatDateTime(item.transaction_date) }}
                  </template>
<template #item.divisi="{ item }" style="white-space: nowrap;word-wrap: break-word;">{{
                    item.divisi_team.name }}</template>
<template #item.customer="{ item }" style="white-space: nowrap;word-wrap: break-word;">{{
                    item.customer.name }}</template>
<template #item.qty_total="{ item }" style="white-space: nowrap;word-wrap: break-word;">{{
                    item.qty_total }}</template>
<template #item.grand_total="{ item }" style="white-space: nowrap;word-wrap: break-word;">{{
                    formatCurrency(item.grand_total) }}</template>
</DataTable>
</div>
</Card1>
</div>
</div> -->
        <div class="col-12 col-md-4">
          <Card1 colClass="col-12" cardClass="card" cardhaderClass="card-no-border pb-0" header="true" title="Rank Team"
            headerTop="true" down="false" cardbodyClass="top-user pt-2" haderTitle="true">
            <div class="d-flex justify-content-end gap-2 mb-2">
              <button class="btn btn-sm btn-success" @click="exportToExcel('team')">
                <i class="fa fa-file-excel"></i>
              </button>
              <button class="btn btn-sm btn-info" @click="downloadCardImage('team-card')">
                <i class="fa fa-image"></i>
              </button>
            </div>
            <ul id="team-card">
              <!-- Header untuk card -->
              <li class="d-flex align-items-center justify-content-between gap-2 bg-light p-2 mb-2 fw-bold">
                <div class="d-flex gap-2">
                  <div>
                    <span>Nama Tim</span>
                  </div>
                </div>
                <span>Total Omset</span>
              </li>
              <!-- Daftar item -->
              <li class="d-flex align-items-center justify-content-between gap-2" v-for="(item, index) in teamDivisi"
                :key="index">
                <div class="d-flex gap-2 py-1">
                  <div>
                    <a href="#">
                      <h6>{{ item.divisi_team_name }}</h6>
                    </a>
                    <p>Order: {{ formatSeparator(item.total_orders) }} ({{
                      formatSeparator(item.total_qty) }})</p>
                  </div>
                </div>
                <span>{{ formatCurrency(item.grand_total) }}</span>
              </li>
            </ul>
          </Card1>
        </div>
        <div class="col-12 col-md-4">
          <Card1 colClass="col-12" cardClass="card" cardhaderClass="card-no-border pb-0" header="true"
            title="Rank Product" headerTop="true" down="false" cardbodyClass="top-user pt-2" haderTitle="true">
            <div class="d-flex justify-content-end gap-2 mb-2">
              <button class="btn btn-sm btn-success" @click="exportToExcel('product')">
                <i class="fa fa-file-excel"></i>
              </button>
              <button class="btn btn-sm btn-info" @click="downloadCardImage('product-card')">
                <i class="fa fa-image"></i>
              </button>
            </div>
            <ul id="product-card">
              <!-- Header untuk card -->
              <li class="d-flex align-items-center justify-content-between gap-2 bg-light p-2 mb-2 fw-bold">
                <div class="d-flex gap-2">
                  <div>
                    <span>Nama Produk</span>
                  </div>
                </div>
                <span>Total Omset</span>
              </li>
              <!-- Daftar item -->
              <li class="d-flex align-items-center justify-content-between gap-2" v-for="(item, index) in rankProduct"
                :key="index">
                <div class="d-flex gap-2 py-1">
                  <div>
                    <a href="#">
                      <h6>{{ item.product_name }}</h6>
                    </a>
                    <p>Order: {{ formatSeparator(item.total_orders) }} ({{
                      formatSeparator(item.order_qty) }})</p>
                  </div>
                </div>
                <span>{{ formatCurrency(item.order_omset) }}</span>
              </li>
            </ul>
          </Card1>
        </div>
        <div class="col-12 col-md-4">
          <Card1 colClass="col-12" cardClass="card" cardhaderClass="card-no-border pb-0" header="true"
            title="Rank Customer" headerTop="true" down="false" cardbodyClass="top-user pt-2" haderTitle="true">
            <div class="d-flex justify-content-end gap-2 mb-2">
              <button class="btn btn-sm btn-success" @click="exportToExcel('customer')">
                <i class="fa fa-file-excel"></i>
              </button>
              <button class="btn btn-sm btn-info" @click="downloadCardImage('customer-card')">
                <i class="fa fa-image"></i>
              </button>
            </div>
            <ul id="customer-card">
              <!-- Header untuk card -->
              <li class="d-flex align-items-center justify-content-between gap-2 bg-light p-2 mb-2 fw-bold">
                <div class="d-flex gap-2">
                  <div>
                    <span>Nama Customer</span>
                  </div>
                </div>
                <span>Total Omset</span>
              </li>
              <!-- Daftar item -->
              <li class="d-flex align-items-center justify-content-between gap-2" v-for="(item, index) in rankCustomer"
                :key="index">
                <div class="d-flex gap-2 py-1">
                  <div>
                    <a href="#">
                      <h6>{{ item.customer_name + " (" + item.customer_phone + ")" }}</h6>
                    </a>
                    <p>Order: {{ formatSeparator(item.total_orders) }} ({{
                      formatSeparator(item.order_qty) }})</p>
                  </div>
                </div>
                <span>{{ formatCurrency(item.order_omset) }}</span>
              </li>
            </ul>
          </Card1>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { ref, watch, reactive, onMounted, defineAsyncComponent } from 'vue'
import DataTable from '@/components/table/DatatableDateRange.vue'
import { toast } from 'vue3-toastify'
import { useSessionStore } from '@/store/session';
import * as XLSX from 'xlsx';
import html2canvas from 'html2canvas';
const session = useSessionStore()
const teamDivisi = ref<any>([])
const divisiTeamOptions = ref<any>([])
const rankCustomer = ref<any>([])
const rankProduct = ref<any>([])
import * as sales from "@/api/services/SalesRequest";
const widgets = ref([
  {
    class: "danger",
    svg1: "cart",
    svg2: "halfcircle",
    number: "0",
    title: "Order",
    font: "font-danger",
    icon: "icon-arrow-up",
    total: "+50%"
  },
  {
    class: "primary",
    svg1: "tag",
    svg2: "halfcircle",
    number: "0",
    title: "Quantity",
    font: "font-primary",
    icon: "icon-arrow-up",
    total: "+70%"
  },
  {
    class: "secondary",
    svg1: "return-box",
    svg2: "halfcircle",
    number: "0",
    title: "Delivery",
    font: "font-secondary",
    icon: "icon-arrow-down",
    total: "-20%"
  },
  {
    class: "success",
    svg1: "rate",
    svg2: "halfcircle",
    number: "0",
    title: "Omset",
    font: "font-success",
    icon: "icon-arrow-up",
    total: "+70%"
  }
])
const Card1 = defineAsyncComponent(() => import("@/components/common/card/CardData1.vue"))

const headers = [
  { text: 'Order No', value: 'code' },
  { text: 'Transaction Date', value: 'transaction_date' },
  { text: 'Divisi', value: 'divisi_team_name' },
  { text: 'Customer', value: 'customer_name' },
  { text: 'Payment', value: 'payment' },
  { text: 'Sales', value: 'sales_name' },
  { text: 'Status', value: 'order_status' },
  { text: 'QTY', value: 'qty_total' },
  { text: 'Grand Total', value: 'grand_total' },
]

const orderHistory = ref<any>([])
const loading = ref(false)
const total = ref(0)

const startdateQuery = ref(new Date().toISOString().split('T')[0] + " 00:00") // Initialize with prop value
const enddateQuery = ref(new Date().toISOString().split('T')[0] + " 23:59") // Initialize with prop value
const params = reactive<DataTableParams>({
  page: 1,
  size: 10,
  search: '',
  divisi_id: session.divisionOptions().find(d => d.name === session.getUser().divisi)?.ID,
  divisi_team_id: "",
  divisi_name: session.divisionOptions().find(d => d.name === session.getUser().divisi)?.name,
  start_date: startdateQuery.value,
  end_date: enddateQuery.value,
})

watch(() => params.divisi_id, (newDivisi) => {
  divisiTeamOptions.value = session.divisionOptions().find(d => d.ID === newDivisi)?.divisiTeams
  params.divisi_team_id = ""
})

const updateParams = (newParams: Partial<DataTableParams>) => {
  Object.assign(params, newParams)
  params.start_date = params.start_date ? new Date(params.start_date).toLocaleString('sv-SE', { timeZone: 'Asia/Jakarta' }).replace(' ', 'T')+"+07:00" : undefined
  params.end_date = params.end_date ? new Date(params.end_date).toLocaleString('sv-SE', { timeZone: 'Asia/Jakarta' }).replace(' ', 'T')+"+07:00" : undefined
  // fetchOrder()
  fetchSalesDashboardWidget()
  fetchSalesDashboardTopDivisi()
  fetchSalesDashboardRankCustomer()
  fetchSalesDashboardRankProduct()
}

function formatDateTime(dateString: string): string {
  if (!dateString) return '';
  const date = new Date(dateString);
  const dd = String(date.getDate()).padStart(2, '0');
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const yyyy = date.getFullYear();
  const hh = String(date.getHours()).padStart(2, '0');
  const min = String(date.getMinutes()).padStart(2, '0');
  return `${dd}-${mm}-${yyyy} ${hh}:${min}`;
}

function formatCurrency(value: number) {
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    minimumFractionDigits: 0
  }).format(value);
}

function formatSeparator(value: number): string {
  return new Intl.NumberFormat('id-ID', {
    style: 'decimal',
    minimumFractionDigits: 0
  }).format(value);
}

const fetchSalesDashboardTopDivisi = async () => {
  loading.value = true
  try {
    // Simulate API delay
    const paramstemp = session.getUser().role == "SALES" ? { ...params, email: session.getUser().email } : params
    paramstemp.start_date = params.start_date ? new Date(params.start_date).toLocaleString('sv-SE', { timeZone: 'Asia/Jakarta' }).replace(' ', 'T')+"+07:00" : undefined
    paramstemp.end_date = params.end_date ? new Date(params.end_date).toLocaleString('sv-SE', { timeZone: 'Asia/Jakarta' }).replace(' ', 'T')+"+07:00" : undefined
    await sales.postRequest("/dashboard/sales-team-rank", paramstemp).then((response) => {
      if (response.data) {
        teamDivisi.value = response.data
      }
    });

  } catch (error) {
    toast.error('Failed to fetch warehouse delivery')
  }
  loading.value = false
}

const fetchSalesDashboardRankCustomer = async () => {
  loading.value = true
  try {
    // Simulate API delay
    const paramstemp = session.getUser().role == "SALES" ? { ...params, email: session.getUser().email } : params
    paramstemp.start_date = params.start_date ? new Date(params.start_date).toLocaleString('sv-SE', { timeZone: 'Asia/Jakarta' }).replace(' ', 'T')+"+07:00" : undefined
    paramstemp.end_date = params.end_date ? new Date(params.end_date).toLocaleString('sv-SE', { timeZone: 'Asia/Jakarta' }).replace(' ', 'T')+"+07:00" : undefined
    await sales.postRequest("/dashboard/sales-rank-customer", paramstemp).then((response) => {
      if (response.data) {
        rankCustomer.value = response.data
      }
    });
  } catch (error) {
    toast.error('Failed to fetch warehouse delivery')
  }
  loading.value = false
}

const fetchSalesDashboardRankProduct = async () => {
  loading.value = true
  try {
    // Simulate API delay
    const paramstemp = session.getUser().role == "SALES" ? { ...params, email: session.getUser().email } : params
    paramstemp.start_date = params.start_date ? new Date(params.start_date).toLocaleString('sv-SE', { timeZone: 'Asia/Jakarta' }).replace(' ', 'T')+"+07:00" : undefined
    paramstemp.end_date = params.end_date ? new Date(params.end_date).toLocaleString('sv-SE', { timeZone: 'Asia/Jakarta' }).replace(' ', 'T')+"+07:00" : undefined
    await sales.postRequest("/dashboard/sales-rank-product", paramstemp).then((response) => {
      if (response.data) {
        rankProduct.value = response.data
      }
    });
  } catch (error) {
    toast.error('Failed to fetch warehouse delivery')
  }
  loading.value = false
}

const fetchSalesDashboardWidget = async () => {
  loading.value = true
  try {
    // Simulate API delay
    const paramstemp = session.getUser().role == "SALES" ? { ...params, email: session.getUser().email } : params
    paramstemp.start_date = params.start_date ? new Date(params.start_date).toLocaleString('sv-SE', { timeZone: 'Asia/Jakarta' }).replace(' ', 'T')+"+07:00" : undefined
    paramstemp.end_date = params.end_date ? new Date(params.end_date).toLocaleString('sv-SE', { timeZone: 'Asia/Jakarta' }).replace(' ', 'T')+"+07:00" : undefined
    await sales.postRequest("/dashboard/sales-widget", paramstemp).then((response) => {
      if (response.data) {
        response.data.forEach((item: any) => {
          widgets.value[0].number = item.order_paid
          widgets.value[1].number = item.order_quantity
          widgets.value[2].number = item.order_delivery
          widgets.value[3].number = item.order_omset
        })
      }
    });

  } catch (error) {
    toast.error('Failed to fetch warehouse delivery')
  }
  loading.value = false
}

async function fetchOrder() {
  loading.value = true
  const paramstemp = session.getUser().role == "SALES" ? { ...params, email: session.getUser().email } : params
    paramstemp.start_date = params.start_date ? new Date(params.start_date).toLocaleString('sv-SE', { timeZone: 'Asia/Jakarta' }).replace(' ', 'T')+"+07:00" : undefined
    paramstemp.end_date = params.end_date ? new Date(params.end_date).toLocaleString('sv-SE', { timeZone: 'Asia/Jakarta' }).replace(' ', 'T')+"+07:00" : undefined
  await sales.postRequest("/order/list", paramstemp).then((res) => {
    if (res.status == 200 && res.data) {
      orderHistory.value = res.data
      total.value = res.total
    } else {
      orderHistory.value = []
      total.value = 0
    }
  })
  loading.value = false
}

const divisiOptions = ref<{ ID: any }[]>([])
// Fungsi untuk export data ke Excel
const exportToExcel = (type: string) => {
  try {
    let data: any[] = [];
    let filename = '';
    
    if (type === 'team') {
      data = teamDivisi.value.map((item: any) => ({
        'Nama Tim': item.divisi_team_name,
        'Total Order': item.total_orders,
        'Total Quantity': item.total_qty,
        'Grand Total': item.grand_total
      }));
      filename = 'rank-team.xlsx';
    } else if (type === 'product') {
      data = rankProduct.value.map((item: any) => ({
        'Nama Produk': item.product_name,
        'Total Order': item.total_orders,
        'Total Quantity': item.order_qty,
        'Grand Total': item.order_omset
      }));
      filename = 'rank-product.xlsx';
    } else if (type === 'customer') {
      data = rankCustomer.value.map((item: any) => ({
        'Nama Customer': item.customer_name,
        'Telepon': item.customer_phone,
        'Total Order': item.total_orders,
        'Total Quantity': item.order_qty,
        'Grand Total': item.order_omset
      }));
      filename = 'rank-customer.xlsx';
    }
    
    if (data.length > 0) {
      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');
      XLSX.writeFile(workbook, filename);
      toast.success(`Data berhasil diexport ke ${filename}`);
    } else {
      toast.error('Tidak ada data untuk diexport');
    }
  } catch (error) {
    console.error('Error exporting to Excel:', error);
    toast.error('Gagal mengexport data ke Excel');
  }
};

// Fungsi untuk export semua data ke Excel
const exportAllToExcel = () => {
  try {
    const workbook = XLSX.utils.book_new();
    
    // Export data tim
    if (teamDivisi.value.length > 0) {
      const teamData = teamDivisi.value.map((item: any) => ({
        'Nama Tim': item.divisi_team_name,
        'Total Order': item.total_orders,
        'Total Quantity': item.total_qty,
        'Grand Total': item.grand_total
      }));
      const teamWorksheet = XLSX.utils.json_to_sheet(teamData);
      XLSX.utils.book_append_sheet(workbook, teamWorksheet, 'Rank Tim');
    }
    
    // Export data produk
    if (rankProduct.value.length > 0) {
      const productData = rankProduct.value.map((item: any) => ({
        'Nama Produk': item.product_name,
        'Total Order': item.total_orders,
        'Total Quantity': item.order_qty,
        'Grand Total': item.order_omset
      }));
      const productWorksheet = XLSX.utils.json_to_sheet(productData);
      XLSX.utils.book_append_sheet(workbook, productWorksheet, 'Rank Produk');
    }
    
    // Export data customer
    if (rankCustomer.value.length > 0) {
      const customerData = rankCustomer.value.map((item: any) => ({
        'Nama Customer': item.customer_name,
        'Telepon': item.customer_phone,
        'Total Order': item.total_orders,
        'Total Quantity': item.order_qty,
        'Grand Total': item.order_omset
      }));
      const customerWorksheet = XLSX.utils.json_to_sheet(customerData);
      XLSX.utils.book_append_sheet(workbook, customerWorksheet, 'Rank Customer');
    }
    
    // Export data widget
    const widgetData = widgets.value.map((item: any) => ({
      'Judul': item.title,
      'Nilai': item.number
    }));
    const widgetWorksheet = XLSX.utils.json_to_sheet(widgetData);
    XLSX.utils.book_append_sheet(workbook, widgetWorksheet, 'Widget');
    
    // Simpan file Excel
    const filename = `sales-dashboard-${new Date().toISOString().split('T')[0]}.xlsx`;
    XLSX.writeFile(workbook, filename);
    toast.success(`Semua data berhasil diexport ke ${filename}`);
  } catch (error) {
    console.error('Error exporting all data to Excel:', error);
    toast.error('Gagal mengexport semua data ke Excel');
  }
};

// Fungsi untuk download gambar dari card
const downloadCardImage = async (elementId: string) => {
  try {
    const element = document.getElementById(elementId);
    if (!element) {
      toast.error('Element tidak ditemukan');
      return;
    }
    
    // Buat clone element untuk menambahkan margin
    const clone = element.cloneNode(true) as HTMLElement;
    const container = document.createElement('div');
    container.appendChild(clone);
    
    // Tambahkan style untuk margin dan header
    container.style.padding = '20px';
    container.style.backgroundColor = '#ffffff';
    container.style.position = 'absolute';
    container.style.left = '-9999px';
    container.style.top = '-9999px';
    container.style.width = '100%';
    container.style.maxWidth = '500px';
    container.style.boxShadow = '0 0 10px rgba(0,0,0,0.1)';
    container.style.borderRadius = '8px';
    
    // Tambahkan judul card di atas
    const title = document.createElement('div');
    title.style.fontSize = '18px';
    title.style.fontWeight = 'bold';
    title.style.marginBottom = '15px';
    title.style.textAlign = 'center';
    title.style.padding = '10px';
    title.style.borderBottom = '1px solid #eee';
    
    // Set judul berdasarkan elementId
    if (elementId === 'team-card') {
      title.textContent = 'Rank Team';
    } else if (elementId === 'product-card') {
      title.textContent = 'Rank Product';
    } else if (elementId === 'customer-card') {
      title.textContent = 'Rank Customer';
    }
    
    // Sisipkan judul sebelum clone
    container.insertBefore(title, container.firstChild);
    
    document.body.appendChild(container);
    
    // Buat canvas dari element dengan clone yang sudah diberi margin
    const canvas = await html2canvas(container, {
      scale: 2,
      useCORS: true,
      allowTaint: true,
      backgroundColor: '#ffffff'
    });
    
    // Hapus container setelah selesai
    document.body.removeChild(container);
    
    // Convert canvas ke data URL
    const dataURL = canvas.toDataURL('image/png');
    
    // Buat link download
    const link = document.createElement('a');
    link.href = dataURL;
    link.download = `${elementId}-${new Date().toISOString().split('T')[0]}.png`;
    link.style.display = 'none';
    
    // Tambahkan ke document, klik, dan hapus
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    toast.success('Gambar berhasil didownload');
  } catch (error) {
    console.error('Error downloading image:', error);
    toast.error('Gagal mendownload gambar');
  }
};

onMounted(() => {
  divisiOptions.value = session.divisionOptions()
  divisiTeamOptions.value = session.divisionOptions().find(d => d.ID === params.divisi_id)?.divisiTeams

  fetchSalesDashboardWidget()
  fetchSalesDashboardTopDivisi()
  fetchSalesDashboardRankCustomer()
  fetchSalesDashboardRankProduct()
})
</script>